'use client';

import Header from '@/components/header';
import SiteFooter from '@/components/site-footer';

export default function PageShell({
  children,
  headerVariant = 'light',
}: {
  children: React.ReactNode;
  headerVariant?: 'dark' | 'light';
}) {
  return (
    <div className="bg-[var(--bm-page)] text-[var(--bm-charcoal)] overflow-x-hidden min-h-screen">
      <Header variant={headerVariant} />
      <div className="pt-[80px] md:pt-[92px]">{children}</div>
      <SiteFooter />
    </div>
  );
}
